import type { ReactElement } from 'react';
import {
  AutonomyGroup,
  type AutonomyGroup as AutonomyGroupType,
} from '@kirin/api-client/contracts/autonomous-execution';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';

interface AutoModeBadgeProps {
  /** YOLO reads "YOLO Mode ON"; anything else "Auto Mode ON". */
  group?: AutonomyGroupType;
  tooltip: string;
}

/**
 * KIR-4024: amber "Auto Mode ON" pill shown next to Claude Code while it runs
 * without per-action approval (KIR-3612 mockups 2 and 3).
 */
export function AutoModeBadge({
  group,
  tooltip,
}: AutoModeBadgeProps): ReactElement {
  const label = group === AutonomyGroup.Yolo ? 'YOLO Mode ON' : 'Auto Mode ON';
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span
          data-testid="auto-mode-badge"
          tabIndex={0}
          className="inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full border border-amber-300 bg-amber-50 px-2 py-0.5 text-xs font-semibold text-amber-800 dark:border-amber-700 dark:bg-amber-950 dark:text-amber-300"
        >
          <span
            aria-hidden="true"
            className="size-1.5 rounded-full bg-amber-500"
          />
          {label}
        </span>
      </TooltipTrigger>
      <TooltipContent>{tooltip}</TooltipContent>
    </Tooltip>
  );
}
